<template>
  <v-container fluid>
    <v-row>
        <v-col>
          <h1 class="headline mb-1">Detalle del documento</h1>
	        <DocumentosFirmadosSimple
           :paqueteId="$route.params.id">
	        </DocumentosFirmadosSimple>
      </v-col>
    </v-row>         
  </v-container>
</template>

<script>


import DocumentosFirmadosSimple from '@/components/DocumentosFirmadosSimple.vue'; 

export default {
  components: { DocumentosFirmadosSimple },
  data: function() {
    return {

    };
  },
  computed: {

  },
  mounted() {
  	//console.log(this.$route);
  },
  methods: {

  },
};
</script>